import { WSInfoBox, WSInfoBoxProps } from "@wingspanhq/fe-component-library";

export const WarningWingspanIsNotAgent: React.FC<WSInfoBoxProps> = props => (
  <WSInfoBox
    title="IMPORTANT:"
    colorBackground="amber50"
    icon="alert"
    {...props}
  >
    Wingspan provides insurance verification services but is not a licensed
    insurance agent or broker. We cannot provide advice about insurance coverage
    or policy decisions. For insurance guidance, please consult a licensed
    insurance professional.
  </WSInfoBox>
);
